import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ReadOnlyService } from './read-only.service';

@Injectable({
  providedIn: 'root'
})
export class ReadOnlyHttpInterceptor implements HttpInterceptor {
  // URLs that are read / search / auth / export queries even though they use POST
  private allowedPostEndpoints: string[] = [
    '/user/get-permissions/',
    '/user/get-role-permissions/',
    '/user/get-user-list/',
    'login',
    'token',
    'auth',
    'search',
    'filter',
    'export',
    'report',
    'dump',
    'download',
    'preview',
    'whatsappReport',
    'pan_verify',
    'gst_verify',
    'verify'
  ];

  constructor(
    private readOnlyService: ReadOnlyService,
    private toastr: ToastrService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If not global read-only, proceed normally
    if (!this.readOnlyService.isReadOnly()) {
      return next.handle(req);
    }

    const method = req.method.toUpperCase();

    // GET, HEAD, OPTIONS are always permitted
    if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS') {
      return next.handle(req);
    }

    // For POST, check if it's an allowed read/search/export query
    if (method === 'POST') {
      const url = req.url.toLowerCase();
      const isAllowed = this.allowedPostEndpoints.some(endpoint =>
        url.includes(endpoint.toLowerCase())
      );

      if (isAllowed) {
        return next.handle(req);
      }
    }

    // Block all other mutating HTTP calls (POST mutations, PUT, PATCH, DELETE)
    console.warn(`[ReadOnlyHttpInterceptor] Blocked mutating ${method} request to:`, req.url);
    this.toastr.warning('Action blocked: Application is in Read-Only mode.', 'Read-Only');

    return throwError(new Error(`Operation blocked: ${method} request to ${req.url} is not permitted in Read-Only mode.`));
  }
}
